import { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";

const NAV_ITEMS = [
  { label: "Servizi", href: "#servizi" },
  { label: "L'Azienda", href: "#azienda" },
  { label: "Progetti", href: "#progetti" },
  { label: "Contatti", href: "#contatti" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050B14]/85 border-b border-[#1E293B]"
          : "bg-transparent border-b border-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 py-5 flex items-center justify-between">
        <a
          href="#top"
          data-testid="logo-link"
          className="flex items-center gap-2 group"
        >
          <div className="w-9 h-9 bg-[#FF5A1F] flex items-center justify-center">
            <span className="text-white font-black text-lg leading-none">D</span>
          </div>
          <div className="leading-none">
            <div className="text-white font-bold tracking-tight text-lg">Dea srl</div>
            <div className="text-[10px] tracking-[0.25em] text-slate-500 uppercase mt-0.5">
              Impresa Edile
            </div>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {NAV_ITEMS.map((item) => (
            <a
              key={item.href}
              href={item.href}
              data-testid={`nav-${item.label.toLowerCase().replace("'", "")}`}
              className="text-sm tracking-wide text-slate-300 hover:text-white link-underline"
            >
              {item.label}
            </a>
          ))}
        </nav>

        <a
          href="#preventivo"
          data-testid="navbar-cta"
          className="hidden md:inline-flex items-center gap-2 bg-[#FF5A1F] hover:bg-[#EA450C] text-white px-5 py-3 text-sm font-semibold tracking-wide transition-colors"
        >
          Richiedi Preventivo <ArrowUpRight size={16} strokeWidth={2.5} />
        </a>

        <button
          data-testid="mobile-menu-toggle"
          onClick={() => setOpen(!open)}
          className="md:hidden w-10 h-10 flex items-center justify-center text-white"
          aria-label="Apri menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div
          data-testid="mobile-menu"
          className="md:hidden bg-[#050B14] border-t border-[#1E293B]"
        >
          <div className="px-6 py-8 flex flex-col gap-6">
            {NAV_ITEMS.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-2xl font-bold text-white tracking-tight"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#preventivo"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 bg-[#FF5A1F] text-white px-6 py-4 text-base font-semibold mt-4 self-start"
            >
              Richiedi Preventivo <ArrowUpRight size={18} />
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
